import { IOnePageShortSections, ONE_PAGE_SHORT_SECTIONS } from "constants/businessToolSections/onePageShort";

export const isOnePageShortSection = (section: any): section is IOnePageShortSections => Object.values(ONE_PAGE_SHORT_SECTIONS).includes(section)